// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__4VB3R","list":"MainNavigation_list__OZtCe","active":"MainNavigation_active__sEUFx"};